import { isReferencedNodeValue } from "@doitintl/cloudflow-commons";
import { ModelType, NodeTransformationType, type ReferencedNodeValue } from "@doitintl/cmp-models";
import * as yup from "yup";

import { createReferencedNodeSchema } from "../../../ApiActionParametersForm/useApiActionParametersSchema";
import type { NodeWitOutputModel } from "../../../ApiActionParametersForm/parameters/wrappers/ReferencedField/useReferencedFieldContext";

function validateReferencedFieldOrString(referenceableNodes: NodeWitOutputModel[]) {
  return yup.mixed().when({
    is: isReferencedNodeValue,
    then: () => createReferencedNodeSchema(referenceableNodes),
    otherwise: () => yup.string().label("Value").required(),
  });
}

export function generateConcatenationSchema(
  referenceableNodes: NodeWitOutputModel[],
  rootReferencedNodeValue: ReferencedNodeValue = {
    referencedField: [],
    referencedNodeId: "",
  }
) {
  return yup.object({
    type: yup.string().default(NodeTransformationType.CONCATENATION),
    newFieldName: yup.string().default("").required().label("New field name").trim(),
    payload: yup
      .array(validateReferencedFieldOrString(referenceableNodes))
      .default([rootReferencedNodeValue.referencedNodeId !== "" ? rootReferencedNodeValue : ""])
      .required(),
  });
}

export function generateStringTransformationCaseSchema(
  type: NodeTransformationType.UPPER_CASE | NodeTransformationType.LOWER_CASE,
  referenceableNodes: NodeWitOutputModel[],
  rootReferencedNodeValue: ReferencedNodeValue = {
    referencedField: [],
    referencedNodeId: "",
  }
) {
  return yup.object({
    type: yup.string().default(type),
    newFieldName: yup.string().default("").required().label("New field name").trim(),
    payload: createReferencedNodeSchema(referenceableNodes, {
      requiredModelType: [ModelType.STRING],
      requiredModelTypeMessage: (label) => `${label} must reference a field with type string`,
    })
      .label("Referenced field")
      .default(rootReferencedNodeValue),
  });
}
